import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <main className="p-8">
      <h1 className="font-display text-2xl font-extrabold">404</h1>
      <p className="text-muted-foreground mb-4">Page not found.</p>
      <Link to="/" className="text-primary underline">
        Go home
      </Link>
    </main>
  );
}
